<template>
  <!-- <div class="page">
    <div class="head-page">
      <div class="member-header p30">
        <el-button class="large-btn" type="primary" @click="addPage">新增</el-button>
      </div>
    </div>
    <div class="mains">
      <p class="title">额度总汇</p>
      <el-row class="rows">
        <el-col class="cols" :span="8">
          <p class="van-text">充值上限</p>
          <p class="van-label mt10">{{ amount.upperAmount }}</p>
        </el-col>
        <el-col class="cols" :span="8">
          <p class="van-text">当月充值</p>
          <p class="van-label mt10">{{ amount.currMonthRechargeTotalAmount }}</p>
        </el-col>
        <el-col class="cols" :span="8">
          <p class="van-text">剩余额度</p>
          <p class="van-label mt10" style="color: #02c346;">{{ amount.currMonthLeftRechargeAmount }}</p>
        </el-col>
      </el-row>
      <p class="title">申请记录</p>
      <div class="rows">
        <el-table :data="list" border>
          <el-table-column prop="rechargeAmount" label="充值金额"></el-table-column>
          <el-table-column prop="auditStatus" label="状态">
            <template slot-scope="scope">
              <span
                style="color: #2896fe;"
                v-if="scope.row.auditStatus == 'wait'"
              >{{ scope.row.auditStatusCn }}</span>
              <span
                style="color: #666;"
                v-if="scope.row.auditStatus == 'pass'"
              >{{ scope.row.auditStatusCn }}</span>
              <span
                style="color: #ee2e2e;"
                v-if="scope.row.auditStatus == 'refuse'"
              >{{ scope.row.auditStatusCn }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请时间" min-width="150px">
            <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
          </el-table-column>
        </el-table>
        <paging :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>-->
  <div class="page">
    <div class="tops-between">
      <div>充值额度</div>
      <div class="member-header">
        <el-button type="primary" class="small-btn" @click="addPage" v-perm="{key:'shopRecharge', value:'shopRecharge:add'}">新增</el-button>
      </div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <p class="order-title-boxs pt16 mt0"><span class="blueBlock"></span><i>额度汇总</i>&nbsp;<span class="fb">{{formatMonthChian(new Date())}}</span></p>
            <el-row class="rows">
              <el-col class="cols" :span="8">
                <p class="van-label">充值上限</p>
                <p class="van-text moneys">{{ amount.upperAmount }}</p>
              </el-col>
              <el-col class="cols" :span="8">
                <p class="van-label">当月充值</p>
                <p class="van-text moneys">{{ amount.currMonthRechargeTotalAmount }}</p>
              </el-col>
              <el-col class="cols" :span="8">
                <p class="van-label">剩余额度</p>
                <p class="van-text" style="color: #62C87F;">{{ amount.currMonthLeftRechargeAmount }}</p>
              </el-col>
            </el-row>
          </div>

          <div class="white br10" v-perm="{key:'shopRecharge', value:'shopRecharge:list'}">
            <p class="order-title-boxs pt16"><span class="blueBlock"></span><i>申请记录</i></p>
            <div class="plr16">
              <el-table :data="list" :max-height="height - 480" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="rechargeAmount" label="充值金额"></el-table-column>
                <el-table-column prop="auditStatus" label="状态">
                  <template slot-scope="scope">
                    <span
                      style="color: #2896fe;"
                      v-if="scope.row.auditStatus == 'wait'"
                    >{{ scope.row.auditStatusCn }}</span>
                    <span
                      style="color: #666;"
                      v-if="scope.row.auditStatus == 'pass'"
                    >{{ scope.row.auditStatusCn }}</span>
                    <span
                      style="color: #ee2e2e;"
                      v-if="scope.row.auditStatus == 'refuse'"
                    >{{ scope.row.auditStatusCn }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="申请时间" min-width="150px" align="right">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
                </el-table-column>
              </el-table>
              <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
export default {
  mixins: [minxin],
  components: { editSet },
  data() {
    return {
      amount: {
        upperAmount: "",
        currMonthRechargeTotalAmount: "",
        currMonthLeftRechargeAmount: "" //销售业绩
      },
      url: this.$url.shopRechargeApply.list,
      query: {
        beginTime: new Date(),
        endTime: new Date()
      },
      height: this.$store.getters.MainHeight,
    };
  },

  created() {
    this.init();
  },

  methods: {
    back() {
      this.$router.push('/collectMoney');
    },
    init() {
      this.$api.post(this.$url.shopRechargeApply.getSet).then(res => {
        if (res) {
          this.amount = res;
        }
        this.totalCounts();
      });
    },
    addPage() {
      this.$refs["editSetForm"].$emit("set");
    },
    totalCounts () {
      this.$api.post(this.$url.shopRechargeApply.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    handleChange(bool) {
      if (bool) {
        this.init();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 100%;
  
}
.tops-between {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;
  }
.mains-content {
  height: calc(100% - 72px);
  
  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 18px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;
      span {
        color: @blue;
      }
    }
    .add-btns {
      width: 100px;
      height: 32px;
    }
  }
  .member-content-box {
  }
  .member-header {
    background: #fff;
    height: 56px;
    padding: 0 25px;
    display: flex;
    align-items: center;

    .setDate {
      margin-right: 15px;
    }
    .top-label {
      width: 90px;
    }
    /deep/ .el-select {
      width: 180px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
        // background: #e1e1e1;
      }
    }
  }
}
.more-boxs {
  display: flex;
}
.boxs-left {
  width: 423px;
  margin-right: 10px;
}
.boxs-center {
  width: 530px;
}
.boxs-right {
  width: 277px;
  margin-left: 10px;
}
.boxs {
  background: #fff;
  // .titles {
  //   font-size: 18px;
  //   font-weight: bold;
  // }
  .titles {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
  }
  .cols {
    text-align: center;
    padding-bottom: 30px;
    .van-label {
      font-size: 14px;
      color: #333;
      margin-bottom: 10px;
    }
    .van-text {
      font-size: 28px;
      font-weight: bold;
    }
  }
}
</style>